import theme from '../../../../../libs/ui/src/theme';

export default theme;
